import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import PdfViewerComponent from "@/components/pdf-viewer/PdfViewerComponent";

const PdfViewerContext = createContext(undefined);

export function PdfViewerProvider({ children }) {
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);

  const openPdfViewer = useCallback((url) => {
    setFileUrl(typeof url === "string" ? url : String(url ?? ""));
    setIsOpenPdfViewer(true);
  }, []);

  const closePdfViewer = useCallback(() => {
    setIsOpenPdfViewer(false);
    setFileUrl(null);
  }, []);

  const togglePdfViewer = useCallback(() => {
    setIsOpenPdfViewer((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({
      isOpenPdfViewer,
      fileUrl,
      openPdfViewer,
      closePdfViewer,
      togglePdfViewer,
    }),
    [closePdfViewer, fileUrl, isOpenPdfViewer, openPdfViewer, togglePdfViewer]
  );

  return (
    <PdfViewerContext.Provider value={value}>
      {children}

      <Dialog
        open={isOpenPdfViewer}
        onOpenChange={(next) => {
          if (!next) closePdfViewer();
        }}
      >
        <DialogContent
          className="flex h-[min(88dvh,calc(100vh-1.5rem))] w-[94vw] max-w-6xl max-h-[92dvh] flex-col gap-0 overflow-hidden p-0 pt-3 sm:h-[88vh]"
          style={{ direction: "rtl" }}
        >
          <DialogHeader className="flex shrink-0 flex-row items-center justify-between space-y-0 border-b px-6 pb-2 pe-14">
            <div className="text-right">
              <DialogTitle className="text-lg">مشاهده گزارش</DialogTitle>
              <DialogDescription className="sr-only">نمایشگر سند پی‌دی‌اف</DialogDescription>
            </div>
          </DialogHeader>

          <div
            className="flex min-h-0 flex-1 flex-col overflow-hidden px-3 pb-2 pt-2"
            data-pdf-dialog-content
          >
            <PdfViewerComponent fileUrl={fileUrl} />
          </div>
        </DialogContent>
      </Dialog>
    </PdfViewerContext.Provider>
  );
}

export function usePdfViewer() {
  const context = useContext(PdfViewerContext);
  if (context === undefined) {
    throw new Error("usePdfViewer باید داخل PdfViewerProvider استفاده شود.");
  }
  return context;
}
